import type { TableProps } from 'antd';
import { Breadcrumb, Button, Table } from 'antd';
import { FiPlus } from 'react-icons/fi';

import { Layout } from '../../components/layout';
import { TopicDrawer } from './components';
import type { TopicsProps, TopicType } from './Topics.types.ts';

import './Topics.styles.css';
import { BREADCRUMBS, TOPICS_COLUMNS } from './Topics.constants.tsx';
import { useTranslation } from 'react-i18next';
import { ConfirmDeleteButton } from '../../components/confirm-delete-button';
import { Skeleton } from '../admin/components';
import { useEffect } from 'react';

export default function Topics({
  topics,
  isLoading,
  openTopicDrawer,
  onOpenTopicDrawer,
  onCloseTopicDrawer,
  onSubmitTopic,
  onDeleteTopics,
  setSelectedTopicKeys,
  topicId,
  itemsToDeleteCount,
}: TopicsProps) {
  const { t } = useTranslation();
  const rowSelection: TableProps<TopicType>['rowSelection'] = {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    onChange: (selectedRowKeys: string[]) => {
      setSelectedTopicKeys(selectedRowKeys);
    },
  };

  useEffect(() => {
    document.title = `Administration ${t('pages.admin.module.topics')}`;
  }, [t]);

  return (
    <Layout>
      {isLoading ? (
        <Skeleton />
      ) : (
        <div className="admin-page">
          <Breadcrumb className="breadcrumb" items={BREADCRUMBS} />

          <div className="admin-page-bar">
            <h1 className="admin-page-bar--title">{t('pages.admin.module.topics')}</h1>
            <div className="admin-page-bar--actions">
              <ConfirmDeleteButton
                onSubmit={onDeleteTopics}
                count={itemsToDeleteCount}
                disabled={itemsToDeleteCount === 0}
              />
              <Button
                icon={<FiPlus />}
                iconPosition="start"
                size="large"
                type="primary"
                onClick={(event) => onOpenTopicDrawer(event, null)}
              >
                {t('common.add-new')}
              </Button>
            </div>
          </div>
          <Table<TopicType>
            rowKey="id"
            rowSelection={{ type: 'checkbox', ...rowSelection }}
            columns={TOPICS_COLUMNS}
            dataSource={topics}
            onRow={(record) => {
              return {
                onClick: (event: React.MouseEvent<HTMLButtonElement>) =>
                  onOpenTopicDrawer(event, record?.id || null),
              };
            }}
          />

          {openTopicDrawer && (
            <TopicDrawer
              open={openTopicDrawer}
              onClose={onCloseTopicDrawer}
              onSubmit={onSubmitTopic}
              topicId={topicId}
            />
          )}
        </div>
      )}
    </Layout>
  );
}
